/*
 * @Author: jsZhao
 * @Date: 2017-12-26 14:21:40
 * @Last Modified by: jsZhao
 * @Last Modified time: 2018-01-09 14:43:17
 * ***** 登录 *****
 */
import fetch from '@/utils/fetch.js'
import {shop_url} from '@/global';
const post = 'post';
const get = 'get';

//获取验证码
const code = (phone)=>{
    return fetch({
        url: `${shop_url}/shop/cms/user/smsCode/${phone}`,
        method: get
    })
}

const login = (phone,captcha)=>{
    return fetch({
        url: `${shop_url}/shop/cms/user/login`,
        data:{
            phone :phone,
            captcha:captcha
        },
        method: post
    })
}

const logout = ()=>{
    return fetch({
        url: `${shop_url}/shop/cms/cmsUser/loginout`,
        method: get,
    })
}
const getQrCodeInfo = ()=>{
  return fetch({
    url:`${shop_url}/shop/cms/user/getQrcode`,
    method:get
  })
}
const qrCodeLogin =(phone,time,id)=> {
  let url =`${shop_url}/shop/cms/user/scanQrcode/${phone}/${id}/${time}`;
  return fetch({
    url:url,
    method:'get'
  })
}

const loginByPhone = (phone,code) =>{
  let url = `${shop_url}/shop/cms/user/qrcodeLogin/`+phone+'/'+code
  return fetch({
    url:url,
    method:'get'
  })
}

const startServer = ()=>{
  let url = `${shop_url}/shop/cms/user/startServer`;
  return fetch({
    url:url,
    method:'get'
  })
}



export { code, login, logout,getQrCodeInfo,qrCodeLogin,loginByPhone,startServer}



// WEBPACK FOOTER //
// ./src/api/login.js